import React, { ReactNode } from 'react';
import { TooltipProps } from '@mui/material/Tooltip';
import { HintTrigger, PreviewImage, TransparentTooltip } from './ImagePreviewTooltip.styles';

export type ImagePreviewTooltipProps = {
  src: string;
  alt: string;
  dimmed?: boolean;
  placement?: TooltipProps['placement'];
  children: ReactNode;
};

export const ImagePreviewTooltip = ({
  src,
  alt,
  dimmed,
  placement = 'right',
  children,
}: ImagePreviewTooltipProps) => (
  <TransparentTooltip
    placement={placement}
    title={
      <PreviewImage
        src={src}
        alt={alt}
        onError={e => {
          e.currentTarget.style.display = 'none';
        }}
      />
    }
  >
    <HintTrigger dimmed={dimmed}>{children}</HintTrigger>
  </TransparentTooltip>
);
